import axios from 'axios'
import qs from 'qs'
import storage from './storage'
import {isObject, isArray, isString, isEmpty, str2timestamp} from './common_funcs'
import apiConfig from '../config/api_config'
import cacheKeys from '../config/cache_keys'

const defaultHeaders = {
    'X-Requested-With': 'XMLHttpRequest'
}

function buildRequestUrl(configKey, opts) {
    if (!isObject(opts)) {
        opts = {
            pathVariables: null,
            queryParams: null
        }
    }

    let requestUrl = apiConfig[configKey].url
    const pathVariables = opts.pathVariables || {}
    const queryParams = opts.queryParams || {}

    requestUrl = requestUrl.replace('http://', '[http]')
    requestUrl = requestUrl.replace('https://', '[https]')

    if (!isEmpty(pathVariables)) {
        const parts = requestUrl.split('/')
        const sb = []

        for (let part of parts) {
            if (isEmpty(part)) {
                continue
            }

            if (!part.startsWith('{') || !part.endsWith('}')) {
                sb.push(part)
            }

            const pathVariableName = part.replace(/^\{/, '').replace(/\}$/, '')

            if (pathVariableName in pathVariables) {
                sb.push(pathVariables[pathVariableName])
            }
        }

        requestUrl = `/${sb.join('/')}`
    }

    if (!isEmpty(queryParams)) {
        requestUrl += (requestUrl.includes('?') ? '&' : '?') + qs.stringify(queryParams)
    }

    if (!requestUrl.includes('[http]') && !requestUrl.includes('[https]')) {
        requestUrl = `${apiConfig.prefix}${requestUrl}`
    }

    requestUrl = requestUrl.replace(/[\/]+/g, '/')
    requestUrl = requestUrl.replace('[http]', '')
    requestUrl = requestUrl.replace('[https]', '')
    return requestUrl
}

async function sendRequest(vm, opts) {
    const pathVariables = opts.pathVariables || {}
    const queryParams = opts.queryParams || {}
    const requestUrl = buildRequestUrl(opts.configKey, {pathVariables, queryParams})
    const headers = isObject(opts.headers) ? Object.assign(opts.headers, defaultHeaders) : defaultHeaders

    const axiosOptions = {
        url: requestUrl,
        responseType: 'json',
        timeout: apiConfig.readTimeout
    }

    const withJwt = !apiConfig[opts.configKey].withoutJwt
    // console.log('withJwt',checkJwt())
    // if (withJwt && !checkJwt()) {
    //     const flag = await refreshJwt()

    //     if (!flag) {
    //         if (vm != null) {
    //             vm.alert('安全令牌已失效<br>刷新安全令牌失败<br>请重新登录', {title: '错误提示'}, () => {
    //                 vm.$router.replace({name: 'login'})
    //             })
    //         }

    //         return Promise.resolve({errno: apiConfig.tokenRefreshException})
    //     }
    // }

    if (withJwt) {
        const jwt = storage.sessionGet(cacheKeys.jwt)
        if (isObject(jwt) && !isEmpty(jwt.accessToken)) {
            headers['Blade-Auth'] = `Bearer ${jwt.accessToken}`
        }
        
        // headers['Authorization'] = "Basic bXA6NkRuITk0NERLMFlCWlQ1dg==";
        headers['Authorization'] = "Basic cGM6NkRuITk0NERkOVlxbFFNTw==";
        // headers['Blade-Auth'] = "Bearer 1eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJpc3N1c2VyIiwiYXVkIjoiYXVkaWVuY2UiLCJ0ZW5hbnRfaWQiOiIxMTA2Iiwicm9sZV9uYW1lIjoiZGVhbGVyIiwidXNlcl9pZCI6IjEwMDA0OTE5IiwidXNlcl9uYW1lIjoiMTE0MTIxIiwidG9rZW5fdHlwZSI6ImFjY2Vzc190b2tlbiIsImFjY291bnQiOiIxMTQxMjEiLCJjbGllbnRfaWQiOiJtcCIsImV4cCI6MTY1MzcwNTk3NywibmJmIjoxNjUzMTAxMTc3fQ.-dyBH1My12GbotWtgms06AnYdt4ceC08w_46rR5j8Ys";
    }

    switch (opts.action) {
        case 'get':
            delete headers['Content-Type']
            axiosOptions.method = 'GET'
            axiosOptions.headers = headers
            break
        case 'post':
            headers['Content-Type'] = 'application/x-www-form-urlencoded'
            axiosOptions.method = 'POST'
            axiosOptions.headers = headers

            if (isObject(opts.requestBody) && !isEmpty(opts.requestBody)) {
                axiosOptions.data = qs.stringify(opts.requestBody)
            } else if (isString(opts.requestBody) && !isEmpty(opts.requestBody)) {
                axiosOptions.data = opts.requestBody
            }

            break
        case 'postJson':
            headers['Content-Type'] = 'application/json'
            axiosOptions.method = 'POST'
            axiosOptions.headers = headers

            if ((isObject(opts.requestBody) || isArray(opts.requestBody)) && !isEmpty(opts.requestBody)) {
                axiosOptions.data = JSON.stringify(opts.requestBody)
            } else if (isString(opts.requestBody) && !isEmpty(opts.requestBody)) {
                axiosOptions.data = opts.requestBody
            }

            break
        case 'postXml':
            headers['Content-Type'] = 'text/xml'
            axiosOptions.method = 'POST'
            axiosOptions.headers = headers

            if (isString(opts.requestBody) && !isEmpty(opts.requestBody)) {
                axiosOptions.data = opts.requestBody
            }

            break
        case 'put':
            headers['Content-Type'] = 'application/json'
            axiosOptions.method = 'PUT'
            axiosOptions.headers = headers

            if ((isObject(opts.requestBody) || isArray(opts.requestBody)) && !isEmpty(opts.requestBody)) {
                axiosOptions.data = JSON.stringify(opts.requestBody)
            } else if (isString(opts.requestBody) && !isEmpty(opts.requestBody)) {
                axiosOptions.data = opts.requestBody
            }

            break
        case 'putXml':
            headers['Content-Type'] = 'text/xml'
            axiosOptions.method = 'PUT'
            axiosOptions.headers = headers

            if (isString(opts.requestBody) && !isEmpty(opts.requestBody)) {
                axiosOptions.data = opts.requestBody
            }

            break
        case 'patch':
            headers['Content-Type'] = 'application/json'
            axiosOptions.method = 'PATCH'
            axiosOptions.headers = headers

            if ((isObject(opts.requestBody) || isArray(opts.requestBody)) && !isEmpty(opts.requestBody)) {
                axiosOptions.data = JSON.stringify(opts.requestBody)
            } else if (isString(opts.requestBody) && !isEmpty(opts.requestBody)) {
                axiosOptions.data = opts.requestBody
            }

            break
        case 'patchXml':
            headers['Content-Type'] = 'text/xml'
            axiosOptions.method = 'PATCH'
            axiosOptions.headers = headers

            if (isString(opts.requestBody) && !isEmpty(opts.requestBody)) {
                axiosOptions.data = opts.requestBody
            }

            break
        case 'delete':
            delete headers['Content-Type']
            axiosOptions.method = 'DELETE'
            axiosOptions.headers = headers
            break
        case 'deleteWithJson':
            headers['Content-Type'] = 'application/json'
            axiosOptions.method = 'DELETE'
            axiosOptions.headers = headers

            if ((isObject(opts.requestBody) || isArray(opts.requestBody)) && !isEmpty(opts.requestBody)) {
                axiosOptions.data = JSON.stringify(opts.requestBody)
            } else if (isString(opts.requestBody) && !isEmpty(opts.requestBody)) {
                axiosOptions.data = opts.requestBody
            }

            break
        case 'deleteWithXml':
            headers['Content-Type'] = 'text/xml'
            axiosOptions.method = 'DELETE'
            axiosOptions.headers = headers

            if (isString(opts.requestBody) && !isEmpty(opts.requestBody)) {
                axiosOptions.data = opts.requestBody
            }

            break
    }
    return new Promise(resolve => {
        try {
            axios(axiosOptions).then(result => {
                const apiResult = parseAxiosResult(result)

                if (!isObject(apiResult)) {
                    resolve({errno: apiConfig.errno.apiCallException})
                    return
                }

                resolve(apiResult)
            }).catch(err => {
                let code = err.response.data.code
                let msg = err.response.data.msg
                // 未授权
                if (code == 401) {
                    // vm.toLogin()
                    return
                }

                resolve(err.response.data)
            })
        } catch (ex) {
            resolve({errno: apiConfig.errno.apiCallException})
        }
    })
}

function checkJwt() {
    const jwt = storage.sessionGet(cacheKeys.jwt)

    if (!isObject(jwt) || isEmpty(jwt.token) || isEmpty(jwt.tokenExpireAt)) {
        return true
    }

    const ts1 = parseInt((new Date()).getTime() / 1000)
    const ts2 = str2timestamp(jwt.tokenExpireAt)

    if (ts2 < 1) {
        return true
    } else {
        return ts1 <= ts2
    }
}

function refreshJwt() {
    const jwt = storage.sessionGet(cacheKeys.jwt)

    if (!isObject(jwt) || isEmpty(jwt.token) || isEmpty(jwt.refreshToken)) {
        return Promise.resolve(true)
    }

    return new Promise(resolve => {
        try {
            axios({
                method: 'POST',
                url: `${apiConfig.prefix}${apiConfig['jwt.refresh'].url}`,
                headers: Object.assign({'Content-Type': 'application/x-www-form-urlencoded'}, defaultHeaders),
                data: qs.stringify({
                    tokenType: apiConfig.tokenType,
                    token: jwt.token,
                    refreshToken: jwt.refreshToken
                }),
                responseType: 'json',
                timeout: apiConfig.readTimeout
            }).then(result => {
                const apiResult = parseAxiosResult(result)

                if (!isObject(apiResult) || !isObject(apiResult.obj) || isEmpty(apiResult.obj.token)) {
                    resolve(false)
                    return
                }

                storage.sessionSet(cacheKeys.jwt, Object.assign(
                    {},
                    storage.sessionGet(cacheKeys.jwt),
                    apiResult.obj
                ))

                resolve(true)
            }).catch(err => {
                resolve(false)
            })
        } catch (ex) {
            resolve(false)
        }
    })
}

function parseAxiosResult(result) {
    if (!isObject(result) || result.status != 200) {
        return {errno: apiConfig.errno.apiCallException}
    }

    let apiResult = null

    if (isString(result.data) && !isEmpty(result.data)) {
        try {
            apiResult = JSON.parse(result.data)
        } catch (ex) {
            apiResult = null
        }
    } else if (isObject(result.data) && !isEmpty(result.data)) {
        apiResult = result.data
    }

    return apiResult
}

const HttpClient = class {
    constructor() {
        this.vm = null
    }

    setVm(vueInstance) {
        this.vm = vueInstance
    }

    get(configKey, queryParams) {
        return sendRequest(this.vm, {action: 'get', configKey, queryParams})
    }

    post(configKey, requestBody) {
        return sendRequest(this.vm, {action: 'post', configKey, requestBody})
    }

    postJson(configKey, requestBody) {
        return sendRequest(this.vm, {action: 'postJson', configKey, requestBody})
    }

    postXml(configKey, xml) {
        return sendRequest(this.vm, {action: 'postXml', configKey, requestBody: xml})
    }

    put(configKey, pathVariables, requestBody) {
        return sendRequest(this.vm, {action: 'put', configKey, pathVariables, requestBody})
    }

    putJson(configKey, pathVariables, requestBody) {
        return this.put(configKey, pathVariables, requestBody)
    }

    putXml(configKey, pathVariables, xml) {
        return sendRequest(this.vm, {action: 'putXml', configKey, pathVariables, requestBody: xml})
    }

    patch(configKey, pathVariables, requestBody) {
        return sendRequest(this.vm, {action: 'patch', configKey, pathVariables, requestBody})
    }

    patchJson(configKey, pathVariables, requestBody) {
        return this.patch(configKey, pathVariables, requestBody)
    }

    patchXml(configKey, pathVariables, xml) {
        return sendRequest(this.vm, {action: 'patchXml', configKey, pathVariables, requestBody: xml})
    }

    delete(configKey, pathVariables) {
        return sendRequest(this.vm, {action: 'delete', configKey, pathVariables})
    }

    deleteWithJson(configKey, pathVariables, requestBody) {
        return sendRequest(this.vm, {action: 'deleteWithJson', configKey, pathVariables, requestBody})
    }

    deleteWithXml(configKey, pathVariables, xml) {
        return sendRequest(this.vm, {action: 'deleteWithXml', configKey, pathVariables, requestBody: xml})
    }
}

export default HttpClient



// WEBPACK FOOTER //
// ./src/libs/http_client.js